import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import CurrentCampaign from '../components/CurrentCampaign';
import About from '../components/About';

export default function render() {
  return (
    <Layout solidHeader={true}>
      <SEO title="Obrigada!" description="Formulário enviado com sucesso." />
      <main className="container">
        <div className="wrap">
          <h1 className="title">Obrigada!</h1>
          <p>Formulário enviado com sucesso.</p>
        </div>
      </main>

      <CurrentCampaign />
      <About />
    </Layout>
  );
}
